import type { Partner } from '../../../../components/LeadFormIndex/types';
import type { FormSchemaV3 } from '../../../../types/preloan/v3';
import { useQuery } from '../../../../utils/helpers';
import shouldShowPlrHero from '../heroVariant';

export const partnerFromSchema = (formSchema: FormSchemaV3): Partner => ({
  partnerName: formSchema.partner,
  partnerEntityName: formSchema.partnerEntityName,
  config: formSchema.config,
  products: formSchema.products,
});

// Misma regla que el paso RUT y la página: foto/panel apagados con ?hero=0,
// hideHero en la config del partner o para banca.me.
export const useShowHero = (formSchema: FormSchemaV3) => {
  const query = useQuery();
  return shouldShowPlrHero({
    backgroundImage: formSchema.config.styles?.backgroundImage,
    hideHero: formSchema.config.preLoanRequestConfig?.hideHero,
    heroQuery: query.get('hero'),
    partnerName: formSchema.partner,
  });
};
